

(function( ){


//------------------------------------------------------------------------------------------------------------------------------


	var Main = function( )
	{
		var _this = this , i ;

		//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -

		// この中に処理を書いていってください。

		new Nav();
		new BtnActive();
		new SubMenu();
		// new NewTicker();
		new ModalBtnSetting();
		// new CollaboMenu();

		window.onload = function() {
			// Accordion.instance['aboutGacha'].open(true);
			// Accordion.instance['joinDrawing'].open(true);
			// Accordion.instance['joinVisits'].open(true);
			// Accordion.instance['wrapping'].open(true);

			// new NewTicker();

			new TopAnim();
			new GachaTwAnim();

			new ScrollEffect();
		}

		//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -

		// リサイズイベントを使うときは、この_onResize内に処理を書いてください。
		// リサイズイベントを綱わないようでしたら決してください。
		// var _onResize = function( )
		// {

		// }

		// _onResize( ) ;
		// FitContents.addTask( _onResize ) ;


	}


//------------------------------------------------------------------------------------------------------------------------------


var Nav = function()
{
	var _this = this , i;

	var _target = document.getElementsByClassName("nav__index");
	var original = _target[1];
	_target[0].def = { className:_target[0].className };
	_target[1].def = { className:_target[1].className };

	var onScroll = function(evt) {
		var scrollY = window.pageYOffset;

		var originalY = original.offsetTop;
		var parent = original.offsetParent;
		while(parent && parent != document.body) {
			originalY += parent.offsetTop;
			parent = parent.offsetParent;
		}

		originalY *= FitContents.zoomScale;

		if(originalY <= scrollY) {
			_target[0].className = _target[0].def.className + " compact";
			_target[1].className = _target[1].def.className + " compact";
		} else {
			_target[0].className = _target[0].def.className;
			_target[1].className = _target[1].def.className;
		}
	}

	window.addEventListener("scroll" , onScroll);
	onScroll();
}


//------------------------------------------------------------------------------------------------------------------------------


var BtnActive = function(){
	var _this = this, i;

	var root = document.getElementsByClassName('nav__index');

	var twBtnOver = root[0].getElementsByClassName('btn-twitter')[0];
	var twBtn = root[1].getElementsByClassName('btn-twitter')[0];

	var gaBtnOver = root[0].getElementsByClassName('btn-gacha')[0];
	var gaBtn = root[1].getElementsByClassName('btn-gacha')[0];

	var gachaContent = document.getElementsByClassName('gacha')[0];
	var twitterContent = document.getElementsByClassName('twitter')[0];

	twBtnOver.defClassName = twBtnOver.className;
	twBtn.defClassName = twBtn.className;

	gaBtnOver.defClassName = gaBtnOver.className;
	gaBtn.defClassName = gaBtn.className;

	ScrollEnterEvent.add( gachaContent, {
		onEnter:function( evt ){
			gaBtnOver.className = gaBtnOver.defClassName + " active";
			gaBtn.className = gaBtn.defClassName + " active";
		},
		onExit:function( evt ){
			gaBtnOver.className = gaBtnOver.defClassName;
			gaBtn.className = gaBtn.defClassName;
		},
		marginScale: 0.4,
		autoRemove: false
	});

	ScrollEnterEvent.add( twitterContent, {
		onEnter:function( evt ){
			twBtnOver.className = twBtnOver.defClassName + " active";
			twBtn.className = twBtn.defClassName + " active";
		},
		onExit:function( evt ){
			twBtnOver.className = twBtnOver.defClassName;
			twBtn.className = twBtn.defClassName;
		},
		marginScale: 0.4,
		autoRemove: false
	});


// 	btnOver.className += " active";
// 	btn.className += " active";

// 	subBtnOver.className += " active";
// 	subBtn.className += " active";
}


//------------------------------------------------------------------------------------------------------------------------------


var SubMenu = function(){
	var _this = this, i;

	var isOpen = false;

	var root = document.getElementsByClassName('nav__index');
	var targetOver = root[0].getElementsByClassName('privilege__container')[0];
	var target = root[1].getElementsByClassName('privilege__container')[0];

	targetOver.defClassName = targetOver.className;
	target.defClassName =target.className;

	var triggerOver = root[0].getElementsByClassName('js-nav-sub')[0];
	var trigger = root[1].getElementsByClassName('js-nav-sub')[0];

	triggerOver.defClassName = triggerOver.className;
	trigger.defClassName =trigger.className;

	// var triggerList = [triggerOver, trigger];

	$([triggerOver, trigger]).on('click', function(){
		if(isOpen) {
			isOpen = false;
			targetOver.className = targetOver.defClassName;
			target.className = target.defClassName;

			triggerOver.className = triggerOver.defClassName;
			trigger.className = trigger.defClassName;
		} else {
			isOpen = true;
			targetOver.className = targetOver.defClassName + ' opened';
			target.className = target.defClassName + ' opened';

			triggerOver.className = triggerOver.defClassName + ' opened';
			trigger.className = trigger.defClassName + ' opened';
		}
	});
}

//------------------------------------------------------------------------------------------------------------------------------


var ModalBtnSetting = function(){
	var _this = this, i;

	var isShopModalOpen = false;
	var shopOpenBtn = document.getElementsByClassName('js-shopModal__btn--open')[0];
	var shopCloseBtn = document.getElementsByClassName('js-shopModal__btn--close')[0];

	shopOpenBtn.defClassName = shopOpenBtn.className;
	shopCloseBtn.defClassName = shopCloseBtn.className;

	$(shopOpenBtn).on('click', function(){
		if(!isShopModalOpen) {
			isShopModalOpen = true;
			shopOpenBtn.className = shopOpenBtn.defClassName + ' show';
		}
	});

	$(shopCloseBtn).on('click', function(){
		if(isShopModalOpen) {
			isShopModalOpen = false;
			shopOpenBtn.className = shopOpenBtn.defClassName + ' hide';
		}
	});

	// var isShareModalOpen = false;
	// var shareOpenBtn = document.getElementsByClassName('js-shareModal__btn--open')[0];
	// var shareCloseBtn = document.getElementsByClassName('js-shareModal__btn--close')[0];

	// shareOpenBtn.defClassName = shareOpenBtn.className;
	// shareCloseBtn.defClassName = shareCloseBtn.className;

	// $(shareOpenBtn).on('click', function(){
	// 	if(!isShareModalOpen) {
	// 		isShareModalOpen = true;
	// 		shareOpenBtn.className = shareOpenBtn.defClassName + ' show';
	// 	}
	// });

	// $(shareCloseBtn).on('click', function(){
	// 	if(isShareModalOpen) {
	// 		isShareModalOpen = false;
	// 		shareOpenBtn.className = shareOpenBtn.defClassName + ' hide';
	// 	}
	// });

}


//------------------------------------------------------------------------------------------------------------------------------


var NewTicker = function(){
	var _this = this, i;

	var newsList = document.getElementsByClassName('nav__index')[1].getElementsByClassName('news__list')[0];

	var item1 = newsList.getElementsByClassName('news__text1');
	var item2 = newsList.getElementsByClassName('news__text2');

	item1.itemWidth = $(item1).width();
	$(item1).css('left', item1.itemWidth + 'px');
	item2.itemWidth = $(item2).width();

	item1.itemCount = -$(item1).width();
	item2.itemCount = 0;

	requestAnimationFrame(update);

	function updateNewsItem() {
		item1.itemWidth = $(item1).width();
		item2.itemWidth = $(item2).width();

		$(item1).css('transform', 'translateX(' + item1.itemCount + 'px)');
		$(item2).css('transform', 'translateX(' + item2.itemCount + 'px)');

		item1.itemCount -= 1;
		item2.itemCount -= 1;

		if(Math.abs(item1.itemCount) >=  Math.abs(item1.itemWidth * 2)) {
			item1.itemCount =  0;
		}

		if(Math.abs(item2.itemCount) >=  Math.abs(item2.itemWidth * 2)) {
			item2.itemCount =  0;
		}
	}

	function update() {
		// パーティクルを更新
		updateNewsItem();

		// 画面の更新
		requestAnimationFrame(update);
	}

	// var slickInitObj = {
	// 	arrows:				false,
	// 	autoplay:			true,
	// 	autoplaySpeed:		0,
	// 	// cssEase:			'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
	// 	cssEase:			'linear',
	// 	dots:				false,
	// 	draggable:			true,
	// 	infinite:			true ,
	// 	initialSlide:		0,
	// 	slidesToShow:		1,
	// 	slidesToScroll:		1,
	// 	speed:				40000,
	// 	swipe:				true,
	// 	swipeToSlide:		true,
	// 	// vertical:			true,
	// };

	// var newsList = document.getElementsByClassName('nav__index')[1].getElementsByClassName('news__list')[0];
	// var ratio = $(newsList).width() / 508 + 0.25;
	// ratio = ratio > 1 ? 1 : ratio;
	// slickInitObj.speed = slickInitObj.speed * ratio;

	// $(newsList).slick(slickInitObj);
}


//------------------------------------------------------------------------------------------------------------------------------

var ScrollEffect = function()
{
	var _this = this , i;

	var lineupContainer = document.getElementsByClassName('gacha__container--lineup')[0];
	var collaboContainer = document.getElementsByClassName('gacha__container--collabo')[0];

	var drawingContainer = document.getElementsByClassName('twitter__container--drawing')[0];
	var visitsContainer = document.getElementsByClassName('twitter__container--visits')[0];

	var targetList = [
		lineupContainer,
		collaboContainer,
		drawingContainer,
		visitsContainer
	];

	for (i = 0; i < targetList.length; i ++) {
		targetList[i].defClassName = targetList[i].className;
	}

	ScrollEnterEvent.add( targetList, {
			onEnter:function( evt ){
				evt.target.className = evt.target.defClassName + ' effect';
			},
			// onExit:function( evt ){
			// 	evt.target.className = evt.target.defClassName + ' effect disable' ;
			// },
			marginScale: 0.2,
			autoRemove: false
	} ) ;
}


//------------------------------------------------------------------------------------------------------------------------------


var TopAnim = function(){
	var _this = this, i;

	var root = document.getElementById('top');
	var fireworks = root.getElementsByClassName('object__fireworks')[0];
	// var talent = root.getElementsByClassName('object__talent')[0];
	var catchElm = root.getElementsByClassName('catch')[0];
	// var charaImage = root.getElementsByClassName('chara__image')[0];

	catchElm.className += " active";
	// charaImage.className += " active";
	fireworks.className += " active";
	// talent.className += " active";

}


//------------------------------------------------------------------------------------------------------------------------------


var GachaTwAnim = function(){
	var _this = this, i;

	var animTarget = [];
	var gachaRoot = document.getElementById('gacha');
	var twRoot = document.getElementById('twitter');

	animTarget = [
		gachaRoot.getElementsByClassName('header')[0],
		gachaRoot.getElementsByClassName('lead')[0],
		gachaRoot.getElementsByClassName('gacha__container--achievement')[0],
		gachaRoot.getElementsByClassName('gacha__container--movie')[0],
		gachaRoot.getElementsByClassName('oragon--top')[0],
		gachaRoot.getElementsByClassName('oragon--bottom')[0],
		twRoot.getElementsByClassName('prize__achievement')[0],
		twRoot.getElementsByClassName('prize__list')[0].getElementsByClassName('prize')[0],
		twRoot.getElementsByClassName('prize__list')[0].getElementsByClassName('prize')[1],
	]

	for (i = 0; i < animTarget.length; i ++) {
		animTarget[i].defClassName = animTarget[i].className;
	}

	ScrollEnterEvent.add(
		animTarget,
		{
			onEnter:function( evt ){
				evt.target.className = evt.target.defClassName + " active";
			},
			// onExit:function( evt ){
			// 	evt.target.className = evt.target.defClassName + " effect disable" ;
			// },
			marginScale: 0.3,
			autoRemove: false
		}
	) ;
}


//------------------------------------------------------------------------------------------------------------------------------


var CollaboMenu = function(){
	var _this = this, i;

	var slickInitObj = {
		arrows:true,
		centerMode: true,
		infinite:true ,
		slidesToShow:1 ,
		slidesToScroll:1 ,
		initialSlide:0 ,
		dots:false ,
		autoplay:false ,
		autoplaySpeed:5000 ,
		swipeToSlide:true ,
		cssEase:'cubic-bezier(0.215, 0.610, 0.355, 1.000)' ,
		speed:350
	};

	var isBtnClick = false;
	var productType = ['product_1', 'product_2', 'product_3'];
	var dateButton = document.getElementsByClassName('gacha__container--collabo')[0].getElementsByClassName('btn__date');
	var menuList = document.getElementsByClassName('gacha__container--collabo')[0].getElementsByClassName('menu__list')[0];

	dateButton[0].defClassName = dateButton[0].className;
	dateButton[1].defClassName = dateButton[1].className;
	dateButton[2].defClassName = dateButton[2].className;

	dateButton[slickInitObj.initialSlide].className += ' active';

	$(dateButton).on('click', function(){
		$(menuList).slick("slickGoTo", $(this).attr('data-jumpIndex'));
	});

	$(menuList).slick(slickInitObj);
	$(menuList).on('beforeChange', function(event, slick, currentSlide, nextSlide) {

		// そのままスライドさせると先頭->最後 最後->先頭 時に巻き戻るような動きになるので修正
		// if(currentSlide == 2 && nextSlide == 0 && isBtnClick == false) {
		// 	charaStatus.slick("slickGoTo", currentSlide + 1);
		// } else if(currentSlide == 0 && nextSlide == 2 && isBtnClick == false) {
		// 	charaStatus.slick("slickGoTo", currentSlide - 1);
		// } else {
		// 	charaStatus.slick("slickGoTo", nextSlide);
		// }

		// isBtnClick = false;

		Tracking.send("change", "index", productType[nextSlide]);

		dateButton[currentSlide].className = dateButton[currentSlide].defClassName;
		dateButton[nextSlide].className = dateButton[nextSlide].defClassName + ' active';
	});

}


//------------------------------------------------------------------------------------------------------------------------------


	window.requestAnimationFrame = 	window.requestAnimationFrame ||
									window.webkitRequestAnimationFrame ||
									function( func ){ return setTimeout( func , 1000/60 ) ; } ;


	window.cancelAnimationFrame = 	window.cancelAnimationFrame ||
									window.webkitCancelAnimationFrame ||
									function( id ){ clearTimeout( id ) ; } ;


	document.readyState === "complete"
		? setTimeout( function(){ new Main( ) ; } , 1 )
		: document.addEventListener( "DOMContentLoaded", function(){ new Main( ) ; } ) ;


//------------------------------------------------------------------------------------------------------------------------------


} )( ) ;

